<app-ods-modal [heading]="data.title" titleId="uploadFilesDialogTitle">
  <app-alert [alertId]="'uploadFileDlg'" [small]="true"></app-alert>

  <p class="upload-hint">{{ toolTip }}</p>

  <div class="upload-file">
    <input
      type="file"
      #filesUpload
      hidden="true"
      [attr.accept]="data.acceptedExtensions"
      id="filesUpload"
      (change)="handleFileInput($event.target.files)"
      [multiple]="data.maxFileCount > 1"
    />
    <button mat-stroked-button color="primary" class="choose-file-button" (click)="filesUpload.click()">
      <mat-icon class="upload-icon" svgIcon="ontario:upload" aria-hidden="true"></mat-icon>Choose file
    </button>
    <span *ngIf="data.maxFileCount <= 1" class="file-name">
      {{ filesToUpload.length > 0 ? filesToUpload[0].fileName : 'No file chosen' }}
    </span>
  </div>

  <ul *ngIf="data.maxFileCount > 1" class="file-list">
    <li *ngIf="filesToUpload.length == 0" class="file-list__item">No file chosen</li>
    <li *ngFor="let f of filesToUpload; let i = index" class="file-list__item">
      <span class="file-name">{{ f.fileName }}</span>
      <button mat-icon-button [matTooltip]="'Remove ' + f.fileName" aria-label="Remove File" (click)="removeFile(i)">
        <mat-icon>clear</mat-icon>
      </button>
    </li>
  </ul>

  <ng-container modalActions>
    <button mat-stroked-button color="primary" (click)="onNoClick()" cdkFocusInitial>Cancel</button>
    <button mat-raised-button color="primary" (click)="onYesClick()" [disabled]="saveDisabled">Upload</button>
  </ng-container>
</app-ods-modal>
